import { Box, Table, Text } from "@radix-ui/themes";
import { AvatarPicker } from "../../components/modals/PersonModal/AvatarPicker";
import moment from "moment";

export function PublicInfo(props: { userObj: IPersonBlock }) {
  return (
    <Box
      style={{
        width: 500,
        maxWidth: "90vw",
      }}
    >
      <Table.Root variant={"surface"}>
        <Table.Body>
          <Table.Row>
            <Table.RowHeaderCell>
              <Text weight={"bold"}>Username</Text>
            </Table.RowHeaderCell>
            <Table.Cell>{props.userObj.blockModel.username}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.RowHeaderCell>
              <Text weight={"bold"}>Name</Text>
            </Table.RowHeaderCell>
            <Table.Cell>
              {props.userObj.blockModel.fname} {props.userObj.blockModel.lname}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.RowHeaderCell>
              <Text weight={"bold"}>Avatar</Text>
            </Table.RowHeaderCell>
            <Table.Cell>
              <AvatarPicker blockObj={props.userObj} canEdit={true} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.RowHeaderCell>
              <Text weight={"bold"}>Last Modified</Text>
            </Table.RowHeaderCell>
            <Table.Cell>
              {moment(props.userObj.blockModel.modified).fromNow()}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </Box>
  );
}
